export const slides = [
  {
    bgType: "bg-type-1",
    imageSrc: "/images/slider/fashion/slider-fashion-1.jpg",
    width: 1920,
    height: 939,
    heading: "Built for Bold",
    subText: "Unleash your confidence with essentials tailored for the modern man.",
    colClass: "col-lg-12 col-12 col-sm-6",
  },
  {
    bgType: "bg-type-2",
    imageSrc: "/images/slider/fashion/slider-fashion-2.jpg",
    width: 944,
    height: 939,
    heading: "Minimal. <br /> Masculine. <br /> Modern.",
    subText: "Elevate your wardrobe with timeless essentials and clean silhouettes.",
    colClass: "col-lg-12 col-12 col-sm-6",
  },
  {
    bgType: "bg-type-3",
    imageSrc: "/images/slider/fashion/slider-fashion-3.jpg",
    width: 1920,
    height: 939,
    heading: "Redefine Your <br /> Standard",
    subText: "Premium quality. Effortless style. Designed for everyday excellence.",
    colClass: "col-lg-5 offset-lg-7 col-sm-6 offset-sm-6 col-12",
  },
];
